import Image from "next/image";
import React from "react";
import styles from "./Section1.module.scss";

export const Section1 = function () {
  return (
    <section id="programme_detail" className={`${styles.section1Container} cc--component-container`}>
      <div className={styles.itemContainer}>
        <div className={styles.itemRow}>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/12/86684f62-icons-harvard-date_000000000000000000001.png"
              alt="Duration"
              height={70}
              width={70}
            />
            <p>
              8 weeks, excluding
              <br />
              orientation
            </p>
          </div>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/12/0e8e59ad-icons-harvard-time-ligth_000000000000000000001.png"
              alt="Effort"
              height={70}
              width={76}
            />
            <p>
              8-10 hours per week,
              <br />
              entirely online
            </p>
          </div>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/12/133c4253-icons-harvard-mods_000000000000000000001.png"
              alt="Learning Format"
              height={70}
              width={70}
            />
            <p>
              Weekly modules,
              <br />
              flexible learning
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
